const splitOnUpperCase = (str) => typeof str === "string" ? str.split(/(?=[A-Z])/).join(" ") : str;

export default splitOnUpperCase;
